<template>
  <div>
    <ui-accordion :label="historyLabel">
      <div v-for="(item, key) in historyList" :key="key">
        <history-item :history-item="item" />
        <hr v-if="shouldDisplaySeparator(key)" class="solid" />
      </div>
    </ui-accordion>
  </div>
</template>

<script>
import HistoryItem from "./HistoryItem.vue";

export default {
  props: {
    historyList: { type: Array, default: null }
  },

  components: {
    HistoryItem
  },

  computed: {
    itemsCount() {
      return this.historyList?.length;
    },

    historyLabel() {
      return this.$t(
        "compliance_reviews.submissionForComplianceReviews.history.label",
        { count: this.itemsCount }
      );
    }
  },

  methods: {
    shouldDisplaySeparator(key) {
      return key < this.historyList.length - 1;
    }
  }
};
</script>

<style scoped>
hr.solid {
  height: 2px;
  margin-bottom: 1rem;
  background-color: var(--divider-color);
  border: 0;
}
</style>
